/*
 * The console's one mark for what learning or the assistant does: a brain on
 * circuits, so a feature driven by AI reads as such wherever it appears, and
 * nothing else wears it. AiBadge is the mark on a tile, for a heading.
 *
 * ! file components/AiIcon.js
 */
import React from "react";
import { LuBrainCircuit } from "react-icons/lu";

export const AiIcon = LuBrainCircuit;

export function AiBadge({ size = 16 }) {
  return (
    <span className="ai-badge" aria-hidden="true">
      <LuBrainCircuit size={size} />
    </span>
  );
}
